export const LOGO = "https://customer-assets-rejwkqb3.emergentagent.net/job_airport-to-hotel-mx/artifacts/lnq9imdw_image.png";

export const IMAGES = {
  heroVan: "https://images.pexels.com/photos/19871521/pexels-photo-19871521.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1920",
  van2: "https://images.pexels.com/photos/19871522/pexels-photo-19871522.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  chauffeur: "https://images.pexels.com/photos/8425035/pexels-photo-8425035.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  chauffeur2: "https://images.pexels.com/photos/8425052/pexels-photo-8425052.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  cancunBeach: "https://images.pexels.com/photos/12333806/pexels-photo-12333806.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  resortAerial: "https://images.pexels.com/photos/6840004/pexels-photo-6840004.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  chichen: "https://images.pexels.com/photos/34302667/pexels-photo-34302667.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  ruins: "https://images.pexels.com/photos/19725123/pexels-photo-19725123.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  resortPool: "https://images.pexels.com/photos/6190475/pexels-photo-6190475.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
};

export const WHATSAPP_NUMBER = "525636298441";
export const OWNER_EMAIL = "info@hrhrivieramaya-cancun.com";

// image mapping per region for destination cards
export const REGION_IMAGE = {
  "Cancun": IMAGES.cancunBeach,
  "Riviera Maya": IMAGES.resortPool,
  "Archaeological Site": IMAGES.chichen,
  "Tourist Site": IMAGES.resortAerial,
};
